<template>
    <div class="rules-item__row rules-item__row--second">
        <v-select
                class="secondary-select"
                v-model="form.operator"
                :items="optionList"
                label="Select Item"
                :append-icon="'mdi-chevron-down'">
        </v-select>
        <InputNumber
                v-if="form.operator === 'less-than' ||
                      form.operator === 'greater-than'"
                v-model="form.value" :description="isMessagesInput ? 'weekly messages' : 'accounts'">
        </InputNumber>
        <InputBetween
                v-else-if="form.operator === 'between'"
                v-model="form.value" :description="isMessagesInput ? 'weekly messages' : 'accounts'">
        </InputBetween>
        <InputText
                v-else
                v-model="form.value"
                :autocomplete="autocomplete">
        </InputText>
    </div>
</template>

<script>
    import InputText from "./InputText";
    import InputNumber from "./InputNumber";
    import InputBetween from "./InputBetween";

    export default {
        name: "RuleValue",
        props: ['value', 'autocomplete', 'options', 'isMessagesInput'],
        components: {
            InputText,
            InputBetween,
            InputNumber
        },
        data: () => ({
            input: null,
            form: {
                operator: null,
                value: null
            }
        }),
        computed: {
            optionList() {
                let allOpts = ['greater-than', 'less-than', 'between',
                    'all-of', 'any-of']
                let label = {
                    'greater-than': 'more than',
                    'less-than': 'less than',
                    'between': 'between',
                    'all-of': 'all of',
                    'any-of': 'any of'
                }
                let options = this.options ? this.options : allOpts
                return _.map(options, o => ({text: label[o], value: o}))
            }
        },
        methods: {},
        watch: {
            'form.operator': function (val, oldVal) {
                // console.log("form operator changed", val, oldVal, this.form.value)
                if (val !== oldVal && oldVal !== null) {
                    // console.log("reset form")
                    if (!((val === "any-of" && oldVal === "all-of") ||
                        ((val === "all-of" && oldVal === "any-of")))) {
                        this.form.value = null
                    }
                }
            },
            form: {
                handler: function (val, oldVal) {
                    // for deep watcher val and oldVal are the same
                    // console.log("Rule value form change", JSON.parse(JSON.stringify(val)))
                    this.$emit('input', val)
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    // for deep watcher val and oldVal are the same
                    // console.log("Rule value value change", JSON.parse(JSON.stringify(val)))
                    if (val !== undefined) {
                        this.form = val
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>
